/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Fact_4_LInputs */

const en_cp_fact_4_l = /** @type {(inputs: Cp_Fact_4_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verification before done`)
};

const id_cp_fact_4_l = /** @type {(inputs: Cp_Fact_4_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verifikasi sebelum selesai`)
};

/**
* | output |
* | --- |
* | "verification before done" |
*
* @param {Cp_Fact_4_LInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_fact_4_l = /** @type {((inputs?: Cp_Fact_4_LInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Fact_4_LInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_fact_4_l(inputs)
	return en_cp_fact_4_l(inputs)
});